import * as types from '../ActionTypes/ProfileActionTypes';
import { UserModel } from '../../BusinessLogic/Models/UserModel';
import { getUserModelsArray } from './helpers';

const initialState = {
    statuses: {
        areFollowersLoading: false,
        isProfileLoading: false,
    },
    followers: [],
    currentProfile: {
        stats: {},
    },
};

export function ProfileReducer(state = initialState, { type, payload, meta, ...actions }) {
    switch (type) {
        // get user profile
        case types.GET_USER_PROFILE_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isProfileLoading: true,
                },
            };
        }

        case types.GET_USER_PROFILE_SUCCESS: {
            const user = new UserModel(payload);

            return {
                ...state,
                currentProfile: { ...user.user },
                statuses: {
                    ...state.statuses,
                    isProfileLoading: false,
                },
            };
        }

        case types.GET_USER_PROFILE_FAILED: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isProfileLoading: false,
                },
            };
        }

        // get followers
        case types.GET_PROFILE_FOLLOWERS_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    areFollowersLoading: true,
                },
            };
        }

        case types.GET_PROFILE_FOLLOWERS_SUCCESS: {
            const followersArray = getUserModelsArray(payload);

            return {
                ...state,
                followers: [...followersArray],
                statuses: {
                    ...state.statuses,
                    areFollowersLoading: false,
                },
            };
        }

        case types.GET_PROFILE_FOLLOWERS_FAILED: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    areFollowersLoading: false,
                },
            };
        }

        case types.RESET_CLASSES_SCROLL: {
            return {
                ...state,
                moreClassesToLoad: true,
            };
        }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/ProfileReducer.js